import { formatIndianCompactNumber } from "../../../../lib/utils";
import { rechartsConfig } from "./BaseChart";

type CustomTooltipProps = {
  active?: boolean;
  payload?: Array<any>;
  label?: string;
};

const isMoneyMetric = (name?: string) =>
  !!name && /amount|fraud|exposure/i.test(name);

const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div
      style={{
        ...rechartsConfig.tooltip.contentStyle,
        padding: "12px 14px",
        minWidth: 260,
      }}
    >
      {label ? (
        <div
          style={{
            fontWeight: 700,
            color: "#0A0A0A",
            marginBottom: 10,
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </div>
      ) : null}

      <div style={{ display: "grid", gap: 10 }}>
        {payload.map((entry: any, index: number) => {
          const name = String(entry?.name ?? "");
          const rawValue = entry?.value;
          const value =
            isMoneyMetric(name) && typeof rawValue === "number"
              ? formatIndianCompactNumber(rawValue, {includeCurrency: true})
              : rawValue;

          return (
            <div
              key={`${name}-${index}`}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 16,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
                <span
                  style={{
                    width: 14,
                    height: 14,
                    borderRadius: 4,
                    backgroundColor: entry?.color,
                    flexShrink: 0,
                  }}
                />
                <span
                  style={{
                    color: "#6B7280",
                    fontWeight: 500,
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {name}
                </span>
              </div>

              <span
                style={{
                  color: "#0A0A0A",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                {value}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CustomTooltip;
